import { render, staticRenderFns } from "./mrecBannerBottom.vue?vue&type=template&id=1b4f3da1&scoped=true&"
import script from "./mrecBannerBottom.vue?vue&type=script&lang=js&"
export * from "./mrecBannerBottom.vue?vue&type=script&lang=js&"
import style0 from "./mrecBannerBottom.vue?vue&type=style&index=0&id=1b4f3da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f3da1",
  null
  
)

export default component.exports